export default __webpack_public_path__ + "static/media/pic79.d0be3e68.jpg";